module.exports = __webpack_public_path__ + "9940923a0bc3892135dee7180d9d770f.svg";